import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import PDFViewer from "./PDFViewer";
import "./PdfLinkViewer.css";

class PdfLinkViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  handleOpen = (e) => {
    e.stopPropagation();
    this.setState({ showModal: true });
  };

  handleClose = () => this.setState({ showModal: false });

  handleDownload = async () => {
    const { url, name } = this.props;
    this.setState({ downloading: true });

    try {
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) throw new Error("Failed to fetch file");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name || "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Download failed. Please try again.");
    } finally {
      this.setState({ downloading: false });
    }
  };

  render() {
    const { name, url, language, onRemove } = this.props;
    const { showModal } = this.state;

    return (
      <div className="pdf-link-viewer">
        {/* PDF name as clickable link */}
        <div className="pdf-link-row">
          <span
            className="pdf-link-name"
            onClick={this.handleOpen}
            title="Click to preview"
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>{" "}
            {name || "PDF Document"}
          </span>
        </div>

        {/* Modal viewer */}
        <Modal
          show={showModal}
          onHide={this.handleClose}
          bsSize="large"
          aria-labelledby="pdf-link-viewer-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="pdf-link-viewer-modal">
              {name || "PDF Viewer"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <PDFViewer url={url} />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleDownload} className='btn btn-primary' style={{ display: 'inline-flex', alignItems: 'center', gap: '6px'}}>
              <i className="fa fa-download" aria-hidden="true"></i> Download
            </Button>
            <Button variant="primary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PdfLinkViewer;
